var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2DLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "IntelliKeyLogo",
    id: "uuid-6cda3b8d-c992-41b7-8824-1d2f4b4b42b6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 7.879,
    y: 7.879,
    width: 44.241,
    height: 44.241,
    rx: 2.797,
    ry: 2.797,
    style: {
      fill: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.524,
    y: 9.524,
    width: 40.951,
    height: 40.951,
    rx: 2.467,
    ry: 2.467,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.841,29.961c-.265,0-.527-.12-.699-.348-.291-.386-.214-.935.172-1.225.855-.645,1.346-1.628,1.346-2.698v-8.482c0-1.862-1.515-3.377-3.377-3.377s-3.377,1.515-3.377,3.377v8.482c0,1.07.49,2.053,1.345,2.698.386.291.463.839.172,1.225-.291.386-.839.462-1.225.171-1.298-.979-2.042-2.471-2.042-4.095v-8.482c0-2.827,2.3-5.126,5.126-5.126s5.126,2.299,5.126,5.126v8.482c0,1.624-.744,3.116-2.042,4.095-.158.119-.343.176-.526.176Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.282,30.365c-.483,0-.875-.392-.875-.875v-4.796c0-.483.392-.875.875-.875s.875.392.875.875v4.796c0,.483-.392.875-.875.875Z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.282,
    cy: 21.659,
    r: 0.879,
    style: {
      fill: "#1a1a1a"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2DLogo);
export default __webpack_public_path__ + "static/media/2DLogo.1b7b91c0dc85abad6bffa553c9184c75.svg";
export { ForwardRef as ReactComponent };